export default require('./messages_en.json');
